import generated from './content.gen.json';

// The build owns validation and hashing; simulation imports only authored data.
export const CONTENT = generated;
